import { useMutation } from '@tanstack/react-query'
import { toast } from '@itsrever/design-system'

interface ProcessActionOptions<TVariables, TData> {
  action: (variables: TVariables) => Promise<TData>
  errorText: string
  onSuccess?: (data: TData, variables: TVariables) => void
  // The backend applies most actions in a workflow that lands a moment later,
  // and the page keeps local mode state, so a delayed reload is the refresh.
  reloadAfterMs?: number
}

export function useProcessAction<TVariables, TData>({
  action,
  errorText,
  onSuccess,
  reloadAfterMs
}: ProcessActionOptions<TVariables, TData>) {
  return useMutation({
    mutationFn: action,
    onSuccess: (data, variables) => {
      onSuccess?.(data, variables)
      if (reloadAfterMs !== undefined) {
        setTimeout(() => window.location.reload(), reloadAfterMs)
      }
    },
    onError: (error) => {
      console.warn(error)
      toast({ variant: 'error', text: errorText })
    }
  })
}
